<template>
  <section class="personal-section">
    <h2 class="section-title">个人信息</h2>
    <div class="info-card">
      <div class="stats-grid">
        <div v-for="(item, index) in statsItems" :key="index" class="stat-item">
          <span class="stat-value">{{ item.value }}</span>
          <span class="stat-label">{{ item.label }}</span>
        </div>
      </div>

      <div class="divider" />

      <div class="withdraw-btns">
        <button
          class="withdraw-btn pink"
          :disabled="withdrawing"
          @click="$emit('withdraw', 'staking')"
        >
          {{ withdrawing ? "处理中..." : "提取质押收益" }}
        </button>
        <button
          class="withdraw-btn purple"
          :disabled="withdrawing"
          @click="$emit('withdraw', 'promotion')"
        >
          {{ withdrawing ? "处理中..." : "提取推广权益" }}
        </button>
        <button
          class="withdraw-btn orange"
          :disabled="withdrawing"
          @click="$emit('withdraw', 'card')"
        >
          {{ withdrawing ? "处理中..." : "提取卡牌权益" }}
        </button>
      </div>

      <div class="totals-grid">
        <div v-for="(item, index) in totalItems" :key="index" class="total-item">
          <span class="total-value">{{ item.value }}</span>
          <span class="total-label">{{ item.label }}</span>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  props: {
    info: {
      type: Object,
      required: true,
    },
    withdrawing: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    statsItems() {
      return [
        { value: this.info.goldCards, label: "金卡" },
        { value: this.info.silverCards, label: "银卡" },
        { value: this.info.bronzeCards, label: "铜卡" },
        { value: this.info.cardReward, label: "卡牌收益" },
        { value: this.info.directReferrals, label: "直推" },
        { value: this.info.directPerformance, label: "直推业绩" },
        { value: this.info.totalPerformance, label: "总业绩" },
        { value: this.info.promotionReward, label: "推广收益" },
      ];
    },
    totalItems() {
      return [
        { value: this.info.withdrawnStaking, label: "已提取质押收益" },
        { value: this.info.withdrawnPromotion, label: "已提取推广收益" },
        { value: this.info.withdrawnCard, label: "已提取卡牌收益" },
      ];
    },
  },
};
</script>

<style lang="scss" scoped>
.personal-section {
  padding: 0 30px 40px;
}

.section-title {
  margin: 0 0 16px;
  font-size: 30px;
  color: #fff;
}

.info-card {
  padding: 20px 16px;
  border-radius: 16px;
  background: #040a28;
}

.stats-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px 8px;
}

.divider {
  margin: 48px 0;
  height: 1px;
  background: rgba(255, 255, 255, 0.12);
}

.stat-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;

  .stat-value {
    margin-bottom: 4px;
    font-size: 26px;
    color: #fff;
    word-break: break-all;
  }

  .stat-label {
    font-size: 22px;
    color: rgba(255, 255, 255, 0.5);
  }
}

.withdraw-btns {
  display: flex;
  gap: 10px;
  margin-bottom: 24px;
}

.withdraw-btn {
  flex: 1;
  height: 44px;
  padding: 0 8px;
  border: none;
  border-radius: 32px;
  font-size: 22px;
  color: #fff;
  cursor: pointer;
  transition: opacity 0.2s;

  &.pink {
    background: #7338ff;
  }

  &.purple {
    background: #7c3aed;
  }

  &.orange {
    background: #f5a623;
  }

  &:hover {
    opacity: 0.9;
  }

  &:active:not(:disabled) {
    opacity: 0.8;
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
}

.totals-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;
}

.total-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;

  .total-value {
    margin-bottom: 4px;
    font-size: 24px;
    color: #fff;
    word-break: break-all;
  }

  .total-label {
    font-size: 20px;
    color: rgba(255, 255, 255, 0.5);
    line-height: 1.3;
  }
}
</style>
